import { render, staticRenderFns } from "./Servicepage.vue?vue&type=template&id=11c0e79c&"
import script from "./Servicepage.vue?vue&type=script&lang=js&"
export * from "./Servicepage.vue?vue&type=script&lang=js&"
import style0 from "./Servicepage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports